import styled from 'styled-components';

export const Root = styled.div`
  max-width: 34rem;
  width: 100%;
  margin: 120px auto 0;
  background: #fff;
  padding: 4rem;
  border-radius: 5px;
  border: 1px solid #cecece;

  /* Semi-global styles */
  & .ant-form-item-control {
    margin-bottom: 0.4rem;
  }

  & .ant-form-item-label {
    padding: 0 0 4px;
  }

  & .ant-form-item-label > label {
    height: 1.2rem;
  }
`;

export const PasswordRulesContainer = styled.ul`
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 0 0 20px;
`;

export const PasswordRuleslTitle = styled.div`
  font-size: 10px;
  margin-top: -10px;
`;

export const PasswordRule = styled.li`
  margin-left: 0;
  font-size: 10px;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-family: ToyotaDisplay;
  font-size: 24px;
  line-height: 30px;
  color: #000;
  margin-bottom: 1rem;
`;

export const ErrorMessage = styled.div`
  margin: 1.6rem 0;
  color: #e50000;
`;
